import React, { useEffect, useState } from 'react'
import './styles.scss'
import MultiLine from 'components/Charts_MultiLine'
import { addDays } from 'components/Charts_Assets'
import Key from 'components/Charts_Key'
import Chart from 'components/Charts_Chart'
import { formatSwissDate } from 'components/Charts_Assets'
import { RangeSlider } from './RangeSlider'

const waves = [
  { start: '2020-02-01', end: '2020-05-31' },
  { start: '2020-06-01', end: '2021-02-28' },
  { start: '2021-03-01', end: '2021-06-30' },
  { start: '2021-07-01', end: '2021-09-30' },
  {
    start: '2021-10-10',
    end: new Date().toISOString().split('T')[0]
  }
]
type drawDataType = {
  d: string
  hosp: number
  icu: number
  vent: number
}[]
export const Hospitalisation = () => {
  const [drawData, setDrawData] = useState<drawDataType | undefined>()
  const [peakPoints, setPeakPoints] = useState<
    { d: string; v: number; t: string }[][]
  >()
  const [xDomain, setXDomain] = useState<Date[]>([
    new Date('2021-10-01'),
    addDays(120, new Date())
  ])

  useEffect(() => {
    console.log('CHANGE', xDomain)
  }, [xDomain])
  useEffect(() => {
    fetch(
      'https://ta-interaktiv.storage.googleapis.com/corona-dashboard/ZH-Hospitalisation.json'
    )
      .then(response => response.json())
      .then(data => {
        const props = ['hosp', 'icu']

        const peaks = props
          .map(prop => {
            return waves.map(wave => {
              const waveData = data.filter(
                m =>
                  new Date(m.d) >= new Date(wave.start) &&
                  new Date(m.d) <= new Date(wave.end)
              )

              const wavemax = Math.max(...waveData.map(m => m[prop]))
              const wavepos = data.findIndex(f => f.d === wave.start)
              const peakpos = waveData.findIndex(f => f[prop] === wavemax)
              return {
                d: data[wavepos + peakpos].d,
                v: wavemax,
                t: wavemax.toString()
              }
            })
          })
          .map(m => m.filter(f => new Date(f.d) < addDays(-7, new Date())))

        setDrawData(data as drawDataType)
        setPeakPoints(peaks)
      })
  }, [])
  console.log('CHANGE', xDomain)

  return (
    <div className='hosp'>
      <Chart
        title='Covid-19-Patienten aktuell in Spitalpflege'
        sub={
          drawData
            ? 'bis ' + formatSwissDate(drawData[drawData.length - 1].d)
            : undefined
        }
        source={
          <>
            Quelle:{' '}
            <a
              href='https://raw.githubusercontent.com/openZH/covid_19/master/fallzahlen_kanton_zh/COVID19_Belegung_Intensivpflege.csv'
              target='_blank'
            >
              Gesundheitsdirektion Kanton Zürich
            </a>
          </>
        }
      >
        <div className='Hospitalisation'>
          {!drawData && <>Daten werden geladen...</>}

          {drawData && (
            <>
              <Key
                entries={[
                  {
                    type: 'line',
                    label: 'Hospitalisiert',
                    color: '#2ca29f'
                  },
                  {
                    type: 'line',
                    label: 'Davon auf der Intensivstation',
                    color: '#d3343f'
                  }
                ]}
              />
              <MultiLine
                data={[
                  drawData
                    .map(m => ({ d: m.d, v: m.hosp }))
                    .filter(
                      f =>
                        new Date(f.d) >= new Date(xDomain[0]) &&
                        new Date(f.d) <= new Date(xDomain[1])
                    ),
                  drawData
                    .map(m => ({ d: m.d, v: m.icu }))
                    .filter(
                      f =>
                        new Date(f.d) >= new Date(xDomain[0]) &&
                        new Date(f.d) <= new Date(xDomain[1])
                    )
                ]}
                yDomain={[600, 0]}
                xDomain={xDomain}
                yTicks={{
                  lines: [0, 200, 400, 600],
                  text: [200, 400, 600]
                }}
                height={400}
                xTicks={{
                  text: ['2020-02-01', '2021-01-01', '2021-10-01'].filter(
                    f =>
                      new Date(f) >= new Date(xDomain[0]) &&
                      new Date(f) <= new Date(xDomain[1])
                  ),
                  lines: ['2020-02-01', '2021-01-01', '2021-10-01'].filter(
                    f =>
                      new Date(f) >= new Date(xDomain[0]) &&
                      new Date(f) <= new Date(xDomain[1])
                  )
                }}
                className='hospitalisation'
                annotations={
                  peakPoints
                    ? peakPoints.filter(
                        f =>
                          new Date(f.d) >= new Date(xDomain[0]) &&
                          new Date(f.d) <= new Date(xDomain[1])
                      )
                    : undefined
                }
              />
            </>
          )}
        </div>
      </Chart>
      <RangeSlider
        labels={['Zeitraum']}
        lang={'de-CH'}
        change={setXDomain}
        initial={xDomain}
      />
    </div>
  )
}
